import { Stack, Typography } from '@mui/material';
import tokens from '@verifime/design-tokens';
import { DvsErrorTooltip } from './DvsErrorTooltip';
import { toDvsStatusLabel, toDvsStatusTone, TDvsStatusTone } from './statusPresentation';
import { TDvsStatusWithErrorDetails } from './types';

const TONE_COLOURS: Record<TDvsStatusTone, string> = {
  positive: 'success.main',
  negative: 'error.main',
  neutral: 'text.secondary',
};

/**
 * Component for displaying DVS status and error details
 */
export const DvsStatusDisplay = ({
  status,
  errorDetails,
}: Readonly<TDvsStatusWithErrorDetails>) => {
  return (
    <Stack direction="row" gap={tokens.spacingXs}>
      {status && (
        <Typography color={TONE_COLOURS[toDvsStatusTone(status)]}>
          {toDvsStatusLabel(status)}
        </Typography>
      )}
      {errorDetails && <DvsErrorTooltip errorDetails={errorDetails} />}
    </Stack>
  );
};
